<template lang="pug">
.item.d-flex.flex-column.flex-md-row
  img.flex-shrink-0(:src="item.Image")
  .content.i_ml_6.i_ml_md_4.i_ml_sm_0
    h5.i_mr_8.i_mr_md_0 {{ item.Title }}
    p.i_body_l.i_mr_8.i_mr_md_0 {{ item.Brief }}
    .read_more_btn.btn_blue_ci(@click="btnClick") 繼續閱讀
</template>

<script>
export default {
  name: "NewsItem",
  props: {
    item: Object,
  },
  methods: {
    btnClick() {
      if (this.item.Type == "news") {
        this.$router.push({
          name: "Detail",
          query: { type: "news", id: this.item.NewsID },
        });
      } else if (this.item.Type == "announcement") {
        this.$router.push({
          name: "Detail",
          query: { type: "announcement", id: this.item.AnnouncementID },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  border-radius: 17px;
  box-shadow: 1px 2px 3px 0 rgba(216, 216, 216, 0.25);
  border: solid 1px #cacccf;
  background-color: #ffffff;
  padding: 30px 40px;
}

img {
  @include size(255px, 194px);
}

h5 {
  @include font(22px, $color_black_text, 500);
}

p {
  font-weight: normal;
}

.links {
  float: right;
  font-size: 14px;

  li {
    margin-left: 20px;
    display: inline-block;
  }

  a {
    color: $color_black_inactive;
    text-decoration: underline;
    cursor: pointer;
  }

  .insured_btn.btn_blue {
    color: white;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    padding-left: 15px;
    padding-right: 15px;
    cursor: pointer;
  }
}

.read_more_btn.btn_blue {
  width: 153px;
  color: white;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  cursor: pointer;
  margin-left: auto;
  margin-right: 0;
  text-align: center;
  font-size: 14px;
}

@media (max-width: 991px) {
  .item {
    padding-left: 30px;
    padding-right: 30px;
  }

  img {
    @include size(204px, 178px);
  }

  h5 {
    font-size: 16px;
  }

  .links {
    li {
      margin-left: 10px;
    }
  }
}

@media (max-width: 767px) {
  img {
    @include size(100%, 39vw);
  }

  h5 {
    margin-top: 30px;
    font-size: 24px;
  }

  .read_more_btn.btn_blue {
    width: 210px;
    height: 45px;
    line-height: 45px;
    font-size: 20px;
    border-radius: 38px;
  }
}

@media (max-width: 575px) {
  .item {
    padding: 5.2vw;
  }

  h5 {
    margin-top: 5.2vw;
    font-size: 4.2vw;
  }

  p {
    font-size: 3.5vw;
  }

  .read_more_btn.btn_blue {
    width: 36.4vw;
    height: 7.8vw;
    line-height: 7.8vw;
    font-size: 3.5vw;
    border-radius: 6.6vw;
  }
}
</style>
